import { render } from "./TrackerList.vue?vue&type=template&id=38a1de80&scoped=true"
import script from "./TrackerList.vue?vue&type=script&lang=js"
export * from "./TrackerList.vue?vue&type=script&lang=js"

import "./TrackerList.vue?vue&type=style&index=0&id=38a1de80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38a1de80"

export default script